import React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import { EmptyLabel } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
const useClasses = makeStyles()((theme) => ({
  keyValueCellTitle: {
    padding: theme.spacing(2, 0),
    lineHeight: "32px"
  },
  keyValueCellValue: {
    padding: theme.spacing(2, 0),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    lineHeight: "32px",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    "& > *": {
      width: "100%"
    }
  },
  keyValueCellTitleCard: {
    padding: theme.spacing(1, 0),
    lineHeight: "20px !important"
  },
  keyValueCellValueCard: {
    padding: theme.spacing(1, 0),
    lineHeight: "20px !important",
    justifyContent: "end",
    whiteSpace: "unset",
    textAlign: "end"
  },
  keyValueCellUnderlined: {
    display: "flex",
    alignItems: "center",
    "&:not(:nth-last-child(-n+2))": {
      borderBottom: `1px solid ${theme.palette.secondary.light}`
    }
  },
  keyValueCellWithOverflow: {
    overflow: "visible"
  },
  keyValueCellTitlePinned: {
    alignItems: "start"
  }
}));
function KeyValueCell({
  title,
  children,
  withOverflow = false,
  titleVariant = "subtitle1",
  isUnderlined = true,
  mode = "default",
  pinTitleToTop = false,
  withEmptyCheck
}) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: cx({ [classes.keyValueCellUnderlined]: isUnderlined, [classes.keyValueCellTitlePinned]: pinTitleToTop }) }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      variant: titleVariant,
      className: cx({ [classes.keyValueCellTitle]: isUnderlined, [classes.keyValueCellTitleCard]: mode === "card" })
    },
    title
  )), /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.keyValueCellValue, {
        [classes.keyValueCellWithOverflow]: withOverflow,
        [classes.keyValueCellValueCard]: mode === "card",
        [classes.keyValueCellUnderlined]: isUnderlined
      })
    },
    withEmptyCheck && !children ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }) : children
  ));
}
export {
  KeyValueCell
};
//# sourceMappingURL=KeyValueCell.js.map
